import LacunaWebPKI from 'web-pki';

var lacunaLicense = {
  "format": 2,
  "allowedDomains": [
    "maino.com.br"
  ],
  "homologDomains": [
    "testes.maino.com.br",
    "app.maino.com.br",
    "ip4:10.0.0.0/8",
    "ip4:127.0.0.0/8",
    "ip4:172.16.0.0/12",
    "ip4:192.168.0.0/16"
  ],
  "productLevel": __PRODUCT_LEVEL_CERTIFICADO_A3__,
  "expiration": __EXPIRACAO_CERTIFICADO_A3__,
  "signature": __ASSINATURA_CERTIFICADO_A3__
};

var pki = new LacunaWebPKI(lacunaLicense);
var selectCertificate = $("#certificado_emissor_thumbprint");

function loadCertificates() {
  selectCertificate.html($("<option>", { text: "Selecione o certificado" }));

  pki.listCertificates().success(function (certs) {
    certs.forEach(function(cert) {
      selectCertificate.append($("<option>", {
        value: cert.thumbprint,
        text: cert.subjectName + " Validade: " + cert.validityEnd,
        "data-validityend": cert.validityEnd
      }));
    });
  });
}

function readCertificate(thumbprint) {
  var validityend = selectCertificate.find(":selected").data("validityend");

  pki.readCertificate(thumbprint).success(function (certEncoding) {
    document.getElementById('certificado_emissor_chave_publica').value = certEncoding;
    document.getElementById('certificado_emissor_validade').value = validityend;
  });
}

function enableElement(element) {
  if (element.data('cmx:disabled')) {
    element.removeData("cmx:disabled");

    element.off("click.cmxDisable");
  }
}

function disableElement(element) {
  if (!element.data('cmx:disabled')) {
    element.on('click.cmxDisable', function(e) { // prevent further clicking
      e.stopImmediatePropagation();
      return false;
    });

    element.data("cmx:disabled", true);
  }
}

function dadosMensagem(message) {
  if (message.startsWith("No certificate was found with thumbprint")) {
    return {
      mensagem: "O certificado selecionado nas configurações não foi localizado no Web PKI.",
      notificaUsuario: true,
      notificaDesenvolvimento: false
    }
  } else if (message.startsWith("O conjunto de chaves")) {
    return {
      mensagem: "Não foi possível acessar o certificado digital. Por favor, tente remover e inserir o token/cartão e tente novamente.",
      notificaUsuario: true,
      notificaDesenvolvimento: false
    }
  } else if (message.startsWith("Ação cancelada") || (message.startsWith("User cancelled")) || (message.startsWith("A operação foi cancelada"))) {
    return {
      mensagem: message,
      notificaUsuario: false,
      notificaDesenvolvimento: false
    }
  } else if (message.startsWith("O cartão inteligente foi removido")) {
    return {
      mensagem: message,
      notificaUsuario: true,
      notificaDesenvolvimento: false
    }
  } else {
    return {
      mensagem: message,
      notificaUsuario: true,
      notificaDesenvolvimento: true
    }
  }
}

function getSignedXml(url_dados, thumbprint, certificateData, disabledElement, postUrl) {
  disableElement(disabledElement);

  pki.init(function() {
    $.getJSON(url_dados, {}, function(data) {
      pki.signData({
        thumbprint: thumbprint,
        data: data["sign_canon"],
        digestAlgorithm: "SHA-1"
      }).success(function(signature_hash) {
        $.post("/assinatura_xml",
          {
            signature_hash: signature_hash,
            certificate_data: certificateData,
            elemento_assinado: data["elemento_assinado"],
            xml: data["xml"]
          }, function(signedXml) {
          $.post(postUrl, signedXml, null, "script").always(function(){
            enableElement(disabledElement)
          });
        });
      }).error(function(message, error, origin) {
        enableElement(disabledElement);

        const dados = dadosMensagem(message);

        if (dados["notificaUsuario"]) {
          exibe_erro("Não foi possível assinar o XML com seu certificado digital: " + dados["mensagem"]);
        }

        if (dados["notificaDesenvolvimento"]) {
          Sentry.setExtra({
            origin: origin,
            error: error
          });

          Sentry.captureMessage("Erro numa assinatura de XML com certificado A3: " + message, {
            level: 'warning'
          });
        }

        console.log(origin);
        console.log(error);
      });
    });
  });
}

export function inicializaLoadCertificates() {
  pki.init(loadCertificates);
}

Object.assign(globalThis, {
  loadCertificates,
  readCertificate,
  getSignedXml
});
